module.exports = __webpack_public_path__ + "static/img/li_top4.2268b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top4.png
// module id = k+L4
// module chunks = 1